const E = {
  'Changing the Invoice To Company will reset the tests and samples': 'Changing the Invoice To Company will reset the tests and samples',
  'Continue?': 'Continue?',
  Yes: 'Yes',
  No: 'No',
};

const F = {
  'Changing the Invoice To Company will reset the tests and samples': 'En modifiant l’entreprise facturée, cela réinitialisera les analyses et les échantillons',
  'Continue?': 'Continuer ?',
  Yes: 'Oui',
  No: 'Non',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/formsDetailsInvoiceChange.js